import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.link.js";
import { defineComponent as _defineComponent } from 'vue';
import { getKlaviyoFooterId } from '~/helpers/tracking/klaviyo';
import AzImg from '~/components/Atoms/AzImg.vue';
import useMenu from '~/composables/useMenu';
import AzPaymentInfos from '~/components/_next/molecules/AzPaymentInfos.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  props: {
    footerItems: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n;
    var _useMenu = useMenu(),
      getMenuItemLink = _useMenu.getMenuItemLink;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var errorMessage = ref(i18n.t('footer.newsletterError'));
    var klaviyoSubscribeForm = ref(null);
    var klaviyoSubscribeInput;
    var subscribeButton;
    var bottomItems = computed(function () {
      var _props$footerItems, _props$footerItems$bo;
      var bItems = ((_props$footerItems = props.footerItems) === null || _props$footerItems === void 0 ? void 0 : (_props$footerItems$bo = _props$footerItems.bottomNavigationCollection) === null || _props$footerItems$bo === void 0 ? void 0 : _props$footerItems$bo.items) || [];
      return bItems.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          subitems: item.subItemsCollection.items.map(function (subitem) {
            return _objectSpread(_objectSpread({}, subitem), {}, {
              link: getMenuItemLink(subitem)
            });
          }).filter(function (subitem) {
            return subitem.link;
          })
        });
      });
    });
    var socialMedias = computed(function () {
      var _props$footerItems2, _props$footerItems2$s;
      return ((_props$footerItems2 = props.footerItems) === null || _props$footerItems2 === void 0 ? void 0 : (_props$footerItems2$s = _props$footerItems2.socialMediasCollection) === null || _props$footerItems2$s === void 0 ? void 0 : _props$footerItems2$s.items) || [];
    });
    var openFooterDetails = ref(true);
    onMounted(function () {
      openFooterDetails.value = !isMobile.value;
    });
    useLazyAsyncData('component-organism-appFooter', function () {
      setKlaviyoSubscribeForm();
      return true;
    });
    onMounted(function () {
      klaviyoSubscribeInput = document.querySelector('.footer-subscribe input[type=email]');
      subscribeButton = document.querySelector('.footer-subscribe button');
      if (klaviyoSubscribeInput) {
        ['blur', 'focus'].forEach(function (eventType) {
          klaviyoSubscribeInput.addEventListener(eventType, replaceErrorMessage);
        });
        subscribeButton.addEventListener('click', replaceErrorMessage);
      }
    });
    onUnmounted(function () {
      if (!klaviyoSubscribeForm.value) {
        setKlaviyoSubscribeForm();
      }
      if (klaviyoSubscribeInput) {
        ['blur', 'focus'].forEach(function (eventType) {
          klaviyoSubscribeInput.removeEventListener(eventType, replaceErrorMessage);
        });
        subscribeButton.removeEventListener('click', replaceErrorMessage);
      }
    });
    watch(function () {
      return route;
    }, function () {
      var klaviyoFormError = document.querySelector('.footer-subscribe input[type=email]+div>div');
      if (klaviyoFormError) {
        klaviyoFormError.remove();
      }
    }, {
      deep: true
    });

    /**
     * Sets the klaviyo newsletter subscribe form.
     */
    function setKlaviyoSubscribeForm() {
      var clientId = getKlaviyoFooterId(i18n.locale);
      klaviyoSubscribeForm.value = klaviyoSubscribeForm.value || "klaviyo-form-".concat(clientId);
    }

    /**
     * Adds an error message to Klaviyo element
     */
    function replaceErrorMessage() {
      var errorMessageElement = document.querySelector('.footer-subscribe input[type=email]+div>div span');
      if (errorMessageElement) {
        errorMessageElement.innerHTML = errorMessage.value;
      }
    }
    return {
      __sfc: true,
      props: props,
      route: route,
      i18n: i18n,
      getMenuItemLink: getMenuItemLink,
      isMobile: isMobile,
      errorMessage: errorMessage,
      klaviyoSubscribeForm: klaviyoSubscribeForm,
      klaviyoSubscribeInput: klaviyoSubscribeInput,
      subscribeButton: subscribeButton,
      bottomItems: bottomItems,
      socialMedias: socialMedias,
      openFooterDetails: openFooterDetails,
      setKlaviyoSubscribeForm: setKlaviyoSubscribeForm,
      replaceErrorMessage: replaceErrorMessage,
      AzImg: AzImg,
      AzPaymentInfos: AzPaymentInfos
    };
  }
});